import LoginMainMobile from "@/views/Login/login-main-mobile.vue";
import LoginMainEmail from "@/views/Login/login-main-email.vue";
import QRCODE from "@/views/Login/qrcode.vue";
import { getServerConfigBoolean } from "@/service/server";
export default {
  name: "Login",
  components: {
    QRCODE,
    LoginMainMobile,
    LoginMainEmail
  },
  props: {
    login: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      rules: {
        email: [{
          required: true,
          message: $t("irio214", "邮箱必填"),
          trigger: "blur"
        }, {
          pattern: /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
          message: $t("venleq7", "邮箱格式不正确"),
          trigger: "blur"
        }]
      }
    };
  },
  computed: {
    isProd() {
      return getServerConfigBoolean("VUE_APP_SCAN_EWM", true);
    },
    _isMoile() {
      return window.innerWidth < 500;
    }
  },
  methods: {
    handleloginTypeChange(type) {
      let emitValue = {
        loginType: type,
        formData: {
          mobile: "",
          email: "",
          mobileAreaCode: "+86"
        }
      };
      this.$emit("on-change", emitValue);
    },
    noMobileEmail() {
      this.$emit("no-mobile-email");
    },
    // 透传扫码登录结果，供父页面判断成功后的跳转目标。
    onWxLogin(loginResult) {
      this.$emit("on-login-wx", loginResult);
    },
    onSubmitMobilePassword(data) {
      this.$emit("on-submit-mobile-password", data);
    },
    onSubmitMobileCode(data) {
      this.$emit("on-submit-mobile-code", data);
    },
    onSubmitEmailPassword(data) {
      this.$emit("on-submit-email-password", data);
    },
    onSubmitEmailCode(data) {
      this.$emit("on-submit-email-code", data);
    }
  }
};